"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlLabel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@jsonforms/core");
const antd_1 = require("antd");
const assert_never_1 = require("./assert-never");
// This consumes a LabelDescription (+ other formats) in a Control UI Schema
function ControlLabel({ uischema, schema, }) {
    const labelDescription = core_1.Helpers.createLabelDescriptionFrom(uischema, schema);
    const text = labelDescription.show ? labelDescription.text : null;
    const labeledUISchema = uischema;
    if (typeof labeledUISchema.label === "object" &&
        "type" in labeledUISchema.label) {
        const labelType = labeledUISchema.label.type;
        switch (labelType) {
            case "Text":
                return ((0, jsx_runtime_1.jsx)(antd_1.Typography.Text, { ...labeledUISchema.label.textProps, children: text }));
            case "Title":
                return ((0, jsx_runtime_1.jsx)(antd_1.Typography.Title, { ...labeledUISchema.label.titleProps, children: text }));
            default:
                try {
                    (0, assert_never_1.assertNever)(labelType);
                }
                catch (e) {
                    console.error(`Invalid value configured in Control UI Schema for label.type: '${labelType}'`);
                }
        }
    }
    return (0, jsx_runtime_1.jsx)(antd_1.Typography.Title, { children: text });
}
exports.ControlLabel = ControlLabel;
